import { render, staticRenderFns } from "./window-notification.vue?vue&type=template&id=286bcd1f&scoped=true"
import script from "./window-notification.vue?vue&type=script&lang=js"
export * from "./window-notification.vue?vue&type=script&lang=js"
import style0 from "./window-notification.vue?vue&type=style&index=0&id=286bcd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bcd1f",
  null
  
)

export default component.exports